import { useEffect, useState, useRef } from "react";
import ChartsDashboard from "./newChart";


const KmeansClustering = ({blockData})=>{
    
    return <>
        
    </>
}

export default KmeansClustering;
